import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { ESubscriptionProvider, ESubsctiptionGrantType } from "@/domain/enums"
import { UserSubscriptionTransactionViewModel } from "../viewmodels/UserSubscriptionHistoryViewModel"
import moment from "moment"

const STATUS_LABEL: Record<string, string> = {
    paid: 'Pago',
    pending: 'Pendente',
    refunded: 'Reembolsado',
    failed: 'Falhou',
    cancelled: 'Cancelado',
}

const STATUS_COLOR: Record<string, string> = {
    paid: 'text-success',
    pending: 'text-warning',
    refunded: 'text-info',
    failed: 'text-danger',
    cancelled: 'text-muted',
}

const GATEWAY_LABEL: Record<ESubscriptionProvider, string> = {
    [ESubscriptionProvider.STRIPE]: 'Stripe',
    [ESubscriptionProvider.IAP]: 'InApp Purchase',
}

const GRANT_TYPE_LABEL: Record<ESubsctiptionGrantType, string> = {
    [ESubsctiptionGrantType.PURCHASED]: 'Compra',
    [ESubsctiptionGrantType.ADMIN]: 'Admin',
    [ESubsctiptionGrantType.PARTNERSHIP]: 'Parceria',
}

const toViewModel = (item: UserSubscriptionTransaction): UserSubscriptionTransactionViewModel => ({
    ...item,
    formatted_date: moment(item.subscription_date).format('DD/MM/YYYY'),
    formatted_price: parseFloat(item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    gateway_label: GATEWAY_LABEL[item.subscription_provider],
    grant_type_label: GRANT_TYPE_LABEL[item.subscription_grant_type],
    status_label: STATUS_LABEL[item.status] ?? item.status,
    status_color: STATUS_COLOR[item.status] ?? 'text-muted',
})

export default {
    toViewModel,
    toListViewModel: (items: UserSubscriptionTransaction[]) => items.map(toViewModel),
}
